import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import NetflixLogo from '../../assets/svod/netflix-logo.png';
import PeacockLogo from '../../assets/svod/peacock.png';
import AppleLogo from '../../assets/svod/apple-logo.png';
import SearchImg from '../../assets/svod/search.png';
import pic1 from '../../assets/svod/user1.png';
import pic2 from '../../assets/svod/user2.png';
import pic3 from '../../assets/svod/user3.png';
import pic4 from '../../assets/svod/user4.png';
import thin_left_chevron from '../../assets/svod/buttons/thin-left-chevron.png';

import SVODStatus from '../../analytics/analytics-events/SVODStatus';
import { SVODStatusEvent } from '../../analytics/analytics-events/constants';
import { EnvType } from "./constants";
import svodMessages from '../../locales/svod';
import { setSelectedAsset } from '../../redux/actions/SVOD';

class NavigationBar extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			clickedSearch: false,
		};

		this.search = this.search.bind(this);
		this.backArrowNavigation = this.backArrowNavigation.bind(this);
		this.logout = this.logout.bind(this);
		this.closeDropdown = this.closeDropdown.bind(this);
	}

	closeDropdown() {
		this.props.closeDropdown();
	}

	logout() {
		/* Google analytics event */
		let svodStatus = new SVODStatus(SVODStatusEvent.SVODACTION_LOGOUT, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.label = 'init';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);
		
		/* Google analytics event */
		let svodStatus2 = new SVODStatus(SVODStatusEvent.SVODSESSION_TIMER, '', '', false, false, true, false);
		svodStatus2.gaTracker = this.props.tracker;
		svodStatus2.label = 'finish';
		svodStatus2.timecode = Date.now();
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus2);

		this.props.eventHandler({ data: { event_type: "logout", type: "header", action: "logout", time: Date.now() } });
	}

	search() {
		this.props.eventHandler({ 
			data: { 
				event_type: "button_click", 
				type: "search_click", 
				page_location: this.props.page,
				time: Date.now() 
			} 
		});

		this.setState({ clickedSearch: true });
	}

	backArrowNavigation() {
		let assetName;
		let assetId;
		if (this.props.video) {
			assetName = this.props.video.name;
			assetId = this.props.video._id;
		}

		this.props.eventHandler({ 
			data: { 
				event_type: "button_click", 
				type: "back_arrow_click", 
				page_location: this.props.page,
				asset_id: assetId,
				asset_name: assetName,
				time: Date.now() 
			} 
		});
	}

	render() {
		let {
			page,
			environment,
			blockNavigation,
			profilePictureNumber,
			previousSelectedAsset,
			addedClass
		} = this.props;

		let content = (environment) => {
			switch (environment) {
				case EnvType.NETFLIX: {
					let pictureSource = pic1;
					if (profilePictureNumber === 2) pictureSource = pic2;
					if (profilePictureNumber === 3) pictureSource = pic3;
					if (profilePictureNumber === 4) pictureSource = pic4;

					return (
						<div id="svod-header">
							<span className="header-elements-left">
								<Link to="/study"><img id="netflix-logo" src={NetflixLogo}></img></Link>
								<Link to="/study">
									{this.props.intl.formatMessage(svodMessages.home)}
								</Link>
								<Link to="/study/watchlist">
									{this.props.intl.formatMessage(svodMessages.my_list)}
								</Link>
							</span>

							<span className="header-elements-right">
								<img id="search" onClick={this.search} src={SearchImg}></img>
								<img className="user-pic" src={pictureSource} ></img>
								<button onClick={this.logout} className="netflix-logout" id="logout">
									{this.props.intl.formatMessage(svodMessages.log_out)}
								</button>
							</span>
						</div>
					);
				}
				case EnvType.AMAZON: {
					return (
						<div id="amazon-svod-header">
							<span className="amazon-header-left">
								<Link to="/study" id="amazon-logo" onClick={this.closeDropdown} >
									{this.props.intl.formatMessage(svodMessages.prime_video)}
								</Link>
								<Link className="amazon-header-link" onClick={this.closeDropdown} id={page === "home_page" ? "current-page" : ""} to="/study">
									{this.props.intl.formatMessage(svodMessages.home)}
								</Link>
								<Link className="amazon-header-link" id={page === "watchlist" ? "current-page" : ""} to="/study/watchlist">
									{this.props.intl.formatMessage(svodMessages.my_list)}
								</Link>
							</span>

							<span className="header-elements-right">
								<button onClick={this.logout} className="amazon-logout" id="logout">
									{this.props.intl.formatMessage(svodMessages.log_out)}
								</button>
							</span>

						</div>
					);
				}				
				case EnvType.PEACOCK: {
					return (
						<div className={`peacock-svod-header ${blockNavigation ? "disabled-header" : ""}`}>
							<Link to="/study"><img className="peacock-logo" src={PeacockLogo}></img></Link>

							<span className="center-elements">
								<ul className="header-elements">
									<Link to="/study" className="button-link">
										<button>{this.props.intl.formatMessage(svodMessages.browse)}</button>
									</Link>
									<li><p>{this.props.intl.formatMessage(svodMessages.featured)}</p></li>
									<li><p>{this.props.intl.formatMessage(svodMessages.movies)}</p></li>
									<Link to="/study">
										<li className={"current-page"}><p>{this.props.intl.formatMessage(svodMessages.tv_shows)}</p></li>										
									</Link>
									<li><p>{this.props.intl.formatMessage(svodMessages.sports)}</p></li>
									<li><p>{this.props.intl.formatMessage(svodMessages.wwe)}</p></li>
									<li><p>{this.props.intl.formatMessage(svodMessages.kids)}</p></li>
									<li><p>{this.props.intl.formatMessage(svodMessages.news)}</p></li>
									<li><p>{this.props.intl.formatMessage(svodMessages.latino)}</p></li>
								</ul>								
							</span>

						</div>
					);
				}
				case EnvType.APPLETV: {
					if (page.includes("show_page") || page.includes("included-with-apple-tv")) {
						return (
							<div className={`apple-svod-header ${blockNavigation ? "disabled-header" : ""}`}>
								{blockNavigation && (
									<span className="header-elements-left" id='navigationBackArrow' onClick={this.backArrowNavigation} data-tooltip={`${this.props.intl.formatMessage(svodMessages.please_watch_the_episode)}`}>
										<img className="back-arrow" src={thin_left_chevron}></img>
									</span>
								)}

								{!blockNavigation && (
									<span className="header-elements-left" onClick={this.backArrowNavigation}>
										<Link to={this.props.backRoute || "/study"} id='navigationBackArrow'>
											<img className="back-arrow" src={thin_left_chevron}></img>
										</Link>
									</span>
								)}

								<span className="header-elements-right">
									<Link to={this.props.backRoute || "/study"}>
										<img className="apple-button-logo" src={AppleLogo}></img>
										<div>tv+</div>
									</Link>
								</span>
							</div>
						);
					} else if (page === "transaction") {
						return (
							<div className={`apple-svod-header ${blockNavigation ? "disabled-header" : ""}`}>
								<span className="header-elements-left" onClick={() => this.props.setSelectedAsset(previousSelectedAsset)}>
									<Link to={this.props.backRoute || "/study"}>
										<img className="apple-button-logo" src={AppleLogo}></img>
										<div>tv+</div>
									</Link>
								</span>
								
								<span className="header-elements-right">
									<div className="search-box" data-tooltip={`${this.props.intl.formatMessage(svodMessages.not_available)}`}>
										<FontAwesomeIcon icon={faMagnifyingGlass}  />
										Search
									</div>
									<div className="user-icon-container" data-tooltip={`${this.props.intl.formatMessage(svodMessages.not_available)}`}>
										<FontAwesomeIcon icon={faUser}  />
									</div>
								</span>
							</div>
						);
					} else {
						return (
							<div className={`apple-svod-header ${addedClass}`}>
								<span className="center-elements">
									<ul className="header-elements">
										<li onClick={this.props.forceLogout}
											data-tooltip={`${this.props.intl.formatMessage(svodMessages.not_available)}`}>
											<div>{this.props.intl.formatMessage(svodMessages.watch_now)}</div>
										</li>
										<li className={page === "home_page" ? "current-page" : ""}>
											<Link to={this.props.backRoute || "/study"}>
												<img className="apple-button-logo" src={AppleLogo}></img>
												<div>tv+</div>
											</Link>
										</li>
										<li data-tooltip={`${this.props.intl.formatMessage(svodMessages.not_available)}`}><div>{this.props.intl.formatMessage(svodMessages.store)}</div></li>
										<li data-tooltip={`${this.props.intl.formatMessage(svodMessages.not_available)}`}><div>{this.props.intl.formatMessage(svodMessages.sports)}</div></li>
										<li data-tooltip={`${this.props.intl.formatMessage(svodMessages.not_available)}`}>{this.props.intl.formatMessage(svodMessages.library)}</li>

										{this.state.clickedSearch && 
											<li onClick={this.search} data-tooltip={`${this.props.intl.formatMessage(svodMessages.not_available)}`} ><img className="search" src={SearchImg}></img></li>
										}
										{!this.state.clickedSearch && 
											<li onClick={this.search} style={{cursor: 'pointer'}}><img className="search" src={SearchImg}></img></li>
										}
									</ul>
								</span>
							</div>
						);
					}
				}
			}
		};

		return (
			<header >
				{content(environment)}
			</header>
		);
	}
}

const mapStateToProps = (state) => ({
	previousSelectedAsset: state.SVOD.selectedAssets.previousAsset,
	profilePictureNumber: state.SVOD.profilePictureNumber,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	setSelectedAsset: (asset) => dispatch(setSelectedAsset(asset)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(NavigationBar));


// WEBPACK FOOTER //
// ./src/components/svod/navigation-bar.jsx